<template>
    <div>
        <div class="container">
            <div class="handle-box">
                <el-button
                    type="primary"
                    icon="el-icon-lx-add"
                    class="handle-add"
                    @click="addEdit"
                >新增</el-button>
            </div>
            <el-table
                :data="tableData"
                border
                class="table"
                ref="multipleTable"
                header-cell-class-name="table-header"
                v-loading="loading"
            >
                <el-table-column label="序号" align="center" width="50">
                    <template slot-scope="scope">
                        <span>{{scope.$index+1}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="name" label="名称" align="center"></el-table-column>
                <el-table-column label="操作" width="200" align="center">
                    <template slot-scope="scope">
                        <el-button
                            type="text"
                            icon="el-icon-edit"
                            @click="handleEdit(scope.row)"
                        >修改</el-button>
                        <el-button
                            type="text"
                            icon="el-icon-delete"
                            @click="handleDelete(scope.row)"
                        >删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination" v-if="totalPages > 1">
                <el-pagination
                    background
                    layout="prev, pager, next"
                    :current-page="currentPage"
                    :page-size="page_size"
                    :page-count="totalPages"
                    @current-change="handlePageChange"
                ></el-pagination>
            </div>
        </div>

        <el-dialog :visible.sync="editVisible" width="50%" :close-on-click-modal="false">
            <el-form ref="ruleForm" :model="form" :rules="rules" label-width="80px">
                <el-form-item label="名称：" prop="name">
                    <el-input
                     v-model="form.name" @input="onInput()"></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer self-dialog-footer">
                <el-button type="primary" @click="saveEdit('ruleForm')">提 交</el-button>
            </span>
        </el-dialog>

    </div>
</template>

<script>
import http from '../../../api/dorisApiConfig'
export default {
    name: 'Categorieslist',
    data() {
        return {
            tableData: [],
            currentPage: 1,
            totalPages: 1,
            page_size: 10,
            pageTotal: 10,
            page_index: 10,
            loading: false,
            multipleSelection: [],
            editVisible: false,
            is_add: false,
            form: {},
            rules: {
                name: [{ required: true, message: "请填写名称", trigger: "blur" }]
            }
        };
    },
    created() {
        this.getData();
    },
    methods: {
        formatDate(time){
            return new Date(time*1000).Format('YYYY-MM-DD hh:mm:ss');
        },
        getData() {
            let that = this;
            that.loading = true;
            let params = {
                page: that.currentPage,
                page_size: that.page_size
            }
            http.get("admin/categories",{params: params}).then(function(res) {
                that.tableData = res.data.data.categories;
                that.currentPage = res.data.data.current_page;
                that.totalPages = res.data.data.total_pages;
                that.loading = false;
            });
        },
        //选择
        selectHandle(){
            this.currentPage = 1;
            this.getData();
        },
        // 触发搜索按钮
        handleSearch() {
            this.currentPage = 1;
            this.getData();
        },
        // 删除操作
        handleDelete(row) {
            let that = this;
            // 二次确认删除
            that.$confirm('确定要删除吗？', '提示', {
                type: 'warning'
            })
            .then(() => {
                let params = {
                    category_id: row.id
                }
                http.delete("admin/category", {params: params}).then(function(res) {
                    if (res.data.status_code == 200) {
                        that.$message.success('删除成功');
                        that.getData();
                    }else{
                        that.$message.error(res.data.msg);
                    }
                });
            })
            .catch(() => {});
        },
        onInput(){
            this.$forceUpdate();
        },
        // 编辑操作
        handleEdit(row) {
            this.form = {
                category_id: row.id,
                name: row.name
            }
            this.is_add = false;
            this.editVisible = true;
        },
        //新增操作
        addEdit(){
            this.form = {
                name: ''
            }
            this.is_add = true;
            this.editVisible = true;
        },
        // 保存编辑
        saveEdit(formName) {
            let that = this;
            that.$refs[formName].validate(valid => {
                if (valid) {
                    let params = {
                        name: that.form.name
                    };
                    if(that.is_add){
                        http.post("admin/category", params).then(function(res) {
                            if (res.data.status_code == 200) {
                                that.$message.success(`新增成功`);
                                that.getData();
                            }else{
                                that.$message.error(res.data.msg);
                            }
                        });
                    }else{
                        params['category_id'] = that.form.category_id;
                        http.put("admin/category", params).then(function(res) {
                            if (res.data.status_code == 200) {
                                that.$message.success(`修改成功`);
                                that.getData();
                            }else{
                                that.$message.error(res.data.msg);
                            }
                        });
                    }
                    that.editVisible = false;
                } else {
                    console.log("error submit!!");
                    return false;
                }
            });
        },
        // 分页导航
        handlePageChange(val) {
          console.log(val)
            this.currentPage = val;
            this.getData();
        }
    }
};
</script>

<style scoped>
.handle-box {
    margin-bottom: 20px;
}

.handle-select {
    width: 120px;
}

.handle-input {
    width: 300px;
    display: inline-block;
}
.table {
    width: 100%;
    font-size: 14px;
}
.red {
    color: #ff0000;
}
.mr10 {
    margin-right: 10px;
}
.table-td-thumb {
    display: block;
    margin: auto;
    width: 180px;
}
.self-dialog-footer{
    display: block;
    text-align: center;
}
.avatar {
    height: 178px;
    display: block;
    max-width: 100%;
}
.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
}
</style>
